/* clone-rv-videos: carousel video dọc (mũi tên + thanh tiến trình), bấm video để phát/tạm dừng, nút bật/tắt tiếng. */
if (!customElements.get('rv-videos')) {
  class RvVideos extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('.rv-videos__viewport');
      this.track = this.querySelector('[data-track]');
      if (!this.track) return;
      this.slides = Array.from(this.track.querySelectorAll('[data-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-dot]'));
      this.prevBtn = this.querySelector('[data-prev]');
      this.nextBtn = this.querySelector('[data-next]');
      this.index = 0;

      this.addClones();
      this.bindMedia();

      this.prevBtn?.addEventListener('click', () => this.go(this.index - 1));
      this.nextBtn?.addEventListener('click', () => this.go(this.index + 1));
      this.dots.forEach((dot) => dot.addEventListener('click', () => this.go(Number(dot.dataset.dot))));

      let startX = null;
      let startY = null;
      this.viewport.addEventListener(
        'touchstart',
        (e) => {
          startX = e.touches[0].clientX;
          startY = e.touches[0].clientY;
        },
        { passive: true }
      );
      this.viewport.addEventListener(
        'touchend',
        (e) => {
          if (startX === null) return;
          const dx = e.changedTouches[0].clientX - startX;
          const dy = e.changedTouches[0].clientY - startY;
          startX = null;
          if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) this.go(this.index + (dx < 0 ? 1 : -1));
        },
        { passive: true }
      );

      this.onResize = () => this.go(this.index, true);
      window.addEventListener('resize', this.onResize);

      this.onBlockSelect = (e) => {
        const i = this.slides.findIndex((s) => s.contains(e.target) || s === e.target);
        if (i > -1) this.go(i);
      };
      this.addEventListener('shopify:block:select', this.onBlockSelect);

      this.go(0, true);
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.onResize);
    }

    /* Như bản gốc (Replo lặp slide): thêm bản sao sau slide cuối để khoảng trống bên phải luôn có video. */
    addClones() {
      if (this.slides.length < 2) return;
      if (this.track.scrollWidth <= this.viewport.clientWidth) return;
      this.slides.forEach((slide) => {
        const clone = slide.cloneNode(true);
        clone.removeAttribute('data-slide');
        clone.removeAttribute('data-shopify-editor-block');
        clone.setAttribute('aria-hidden', 'true');
        clone.classList.add('is-clone');
        clone.querySelectorAll('button').forEach((b) => b.setAttribute('tabindex', '-1'));
        this.track.appendChild(clone);
      });
    }

    bindMedia() {
      this.track.querySelectorAll('[data-media]').forEach((media) => {
        const video = media.querySelector('video');
        const mute = media.querySelector('[data-mute]');
        if (!video) return;

        const toggle = () => {
          if (video.paused) {
            this.track.querySelectorAll('video').forEach((v) => {
              if (v !== video && !v.paused) v.pause();
            });
            media.classList.add('is-started');
            const p = video.play();
            if (p && p.catch) p.catch(() => {});
          } else {
            video.pause();
          }
        };

        video.addEventListener('play', () => media.classList.add('is-playing', 'is-started'));
        video.addEventListener('pause', () => media.classList.remove('is-playing'));

        media.addEventListener('click', (e) => {
          if (mute && mute.contains(e.target)) return;
          toggle();
        });

        mute?.addEventListener('click', (e) => {
          e.stopPropagation();
          video.muted = !video.muted;
          mute.classList.toggle('is-unmuted', !video.muted);
          mute.setAttribute('aria-label', video.muted ? 'Unmute' : 'Mute');
          if (video.paused) toggle();
        });
      });
    }

    go(i, instant) {
      const max = this.slides.length - 1;
      this.index = Math.max(0, Math.min(max, i));
      const slide = this.slides[this.index];
      if (!slide) return;
      if (instant) this.track.style.transition = 'none';
      this.track.style.transform = `translate3d(${-slide.offsetLeft}px, 0, 0)`;
      if (instant) {
        void this.track.offsetWidth;
        this.track.style.transition = '';
      }
      this.dots.forEach((dot, n) => {
        dot.classList.toggle('is-active', n === this.index);
        dot.setAttribute('aria-current', n === this.index ? 'true' : 'false');
      });
      if (this.prevBtn) this.prevBtn.disabled = this.index === 0;
      if (this.nextBtn) this.nextBtn.disabled = this.index === max;
    }
  }

  customElements.define('rv-videos', RvVideos);
}
